<template>
    <card-renderless v-slot="{
        title,
        abstract,
        link,
        image,
        tag,
        tagLink,
        pageType,
        date,
        truncateString,
    }">
        <div class="relative flex flex-col w-full h-full bg-white rounded shadow-md isolate text-t3m-body">
            <a class="t3m-Card-image-wrapper card-img-top"
               :href="link"
               :aria-label="title">
                <figure class="relative flex justify-center rounded-t aspect-card-image">
                    <img class="object-cover w-full h-full mx-auto rounded-t swiper-lazy"
                         title=""
                         alt=""
                         :data-src="image" />
                    <div class="swiper-lazy-preloader"></div>
                </figure>
            </a>
            <div class="relative flex-grow max-h-full p-4">
                <h3 class="mt-0 mb-2 font-bold">
                    <a class="text-inherit hover:text-primary"
                        v-html="title"
                       :href="link"
                       :aria-label="title"></a>
                </h3>
                <div class="text-sm">
                    {{ truncateString(abstract, 200) }}
                </div>
            </div>
            <footer class="flex items-center p-3 space-x-4 text-xs bg-gray-100 rounded-b md:rounded-b-lg">
                <span class="inline-block w-4 h-4 bg-center bg-no-repeat bg-contain bg-sciencelab-logo"></span>
                <div class="truncate cursor-default t3m-ScienceLab-pagelist-item-publication-date">
                    {{ date }}
                </div>
                <div class="truncate cursor-default t3m-ScienceLab-pagelist-item-type">{{ pageType }}</div>

                <a class="t3m-Popover flex-initial text-center truncate px-1 py-0.5 text-xs rounded-sm bg-t3m-olive-green-200 border border-t3m-olive-green-300 text-t3m-body hover:text-t3m-body inline-block"
                   :href="tagLink"
                   :data-tippy-content="tag"
                   data-tippy-placement="top"
                   :aria-label="tag">{{ tag }}</a>

                <a v-if="link.length"
                   class="!ml-auto flex items-center pl-4"
                   :href="link"
                   aria-label="Read article">
                    <div
                         class="inline-block p-0.5 text-white rounded-full hover:text-white bg-primary hover:bg-primary-hover">
                        <span class="sr-only">Read article</span>
                        <svg xmlns="http://www.w3.org/2000/svg"
                             class="w-3 h-3"
                             viewBox="0 0 448 512"
                             fill="currentColor">
                            <path
                                  d="M432 256C432 269.3 421.3 280 408 280h-160v160c0 13.25-10.75 24.01-24 24.01S200 453.3 200 440v-160h-160c-13.25 0-24-10.74-24-23.99C16 242.8 26.75 232 40 232h160v-160c0-13.25 10.75-23.99 24-23.99S248 58.75 248 72v160h160C421.3 232 432 242.8 432 256z">
                            </path>
                        </svg>
                    </div>
                </a>
            </footer>
        </div>
    </card-renderless>
</template>

<script>
import CardRenderless from "@/components/Card/CardRenderless";
export default {
    components: {
        CardRenderless,
    },
    mounted() {

        if (window.tippy) {
            var readyForPopoverEvent = new CustomEvent('readyForPopover');
            document.dispatchEvent(readyForPopoverEvent);
        }
    }
};
</script>
